import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { getBanks } from "../../../http/api/BankAPI";

const BankSelect = ({ name, ...props }) => {
  const [listBank, setListBank] = useState([]);
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    GetBank();
  }, []);

  async function GetBank() {
    try {
      const response = await getBanks();
      setListBank(response.data ?? response);
    } catch (error) {
      console.error("Failed to fetch bank types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
    props.moveNext();
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listBank.map((type) => (
          <MenuItem key={type.bankCd} value={type.bankCd}>
            {type.bankName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default BankSelect;
